
@if (pw.id) {
  <div>
    <form nz-form [nzLayout]="'vertical'" class="m-d-off" >
      <div nz-row  [nzGutter]="bas.ui.gridMd.gutter" nzAlign="top" >
        @if (pw.findTimeAreas?.length > 1) {
          <div nz-col
            [nzXs]="view.grid.guests.xs"
            [nzSm]="view.grid.guests.sm"
            [nzMd]="view.grid.guests.md"
            [nzLg]="view.grid.guests.lg"
            [nzXl]="view.grid.guests.xl"
            [nzXXl]="view.grid.guests.xxl"
            class=""
            >
            <nz-form-item>
              <nz-form-label  class="" nzFor="">{{ 'common.venue' | actrans }}</nz-form-label>
              <nz-form-control [nzErrorTip]="'common.venue'  | actrans | str">
                <div>
                  <nz-input-group nzPrefixIcon="pushpin"  [nzSize]="view.size">
                    <nz-select
                      [(ngModel)]="pw.areaId"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onAreaChange($event)"
                      >
                      <nz-option
                        [nzValue]="''"
                        [nzLabel]="'--------------'">
                      </nz-option>
                      @for (area of pw.findTimeAreas || []; track area) {
                        <nz-option
                          [nzValue]="area.idAsString"
                          [nzLabel]="area.mkName">
                        </nz-option>
                      }
                    </nz-select>
                  </nz-input-group>
                </div>
              </nz-form-control>
            </nz-form-item>
            <!-- <app-select-guests [pw]="pw" [gcs]="pw.guestCounts" (change)="onGuestsUpdate($event)" ></app-select-guests> -->
          </div>
        }
        @if (!opts.hideDateTime) {
          @if (pw.productObj.tcTime || pw.productObj.tcDate || pw.productObj.tcPeriod) {
            <div nz-col
              [nzXs]="opts.inlineDateTime ? 24 : view.grid.date.xs"
              [nzSm]="opts.inlineDateTime ? 24 : view.grid.date.sm"
              [nzMd]="opts.inlineDateTime ? 24 : view.grid.date.md"
              [nzLg]="opts.inlineDateTime ? 24 : view.grid.date.lg"
              [nzXl]="opts.inlineDateTime ? 24 : view.grid.date.xl"
              [nzXXl]="opts.inlineDateTime ? 24 : view.grid.date.xxl"
              [class.inlineDateTime]="opts.inlineDateTime"
              >
              <nz-form-item>
                <nz-form-label  class="" nzFor="">
                  @if (pw.productObj.tcPeriod && ((pw.productPeriods || []).length == 1)) {
                    {{ 'common.period' | actrans }}
                  } @else {
                    {{ 'app.cbapi5.common.selectDate' | actrans }}
                  }
              
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'app.cbapi5.common.selectDate' | actrans | str">
                  <div>
                    @if (pw.productObj.tcTime || (pw.productObj.tcDate && pw.productObj.singleDateProduct)) {
                      <nz-input-group nzPrefixIcon="calendar"  [nzSize]="view.size">
                        <!-- <input
                        [(ngModel)]="pw.startDateAsJsDate"
                        name="startDateAsJsDate"
                        [ngModelOptions]="{standalone: true}"
                        mbsc-datepicker
                        [mbscOptions]="options.time"
                        [controls]="['calendar']"
                        select="date"
                        display="anchored"
                        [showOnFocus]="false"
                        [invalid]="dateInvalid"
                        [colors]="dateColors"
                        (onPageLoading)="dateOnPageLoading($event)"
                        (onChange)="dateOnChange($event)"
                        class="ant-input"
                        /> -->
                        <!--
                        calendarType="week"
                        [calendarSize]="2"
                        -->
                        <nz-date-picker
                          [(ngModel)]="_pw.startDateAsJsDate"
                          [ngModelOptions]="{standalone: true}"
                          [nzAllowClear]="false"
                          [nzInputReadOnly]="bas.ui.r.xs"
                          [nzDisabledDate]="disabledDate"
                          [nzShowToday]="false"
                          (ngModelChange)="dateOnChange($event)"
                          nzBorderless
                          [nzInline]="false"
                          class="w-100 no-border"
                        ></nz-date-picker>
                      </nz-input-group>
                    }
                    <!-- <nz-input-group *ngIf="pw.productObj.tcDate && !pw.productObj.singleDateProduct" nzPrefixIcon="calendar"  [nzSize]="view.size">
                    <input
                      [(ngModel)]="pw.periodArray"
                      name="periodArray"
                      [ngModelOptions]="{standalone: true}"
                      mbsc-datepicker
                      [mbscOptions]="options.date"
                      [controls]="['calendar']"
                      select="range"
                      display="anchored"
                      [showOnFocus]="false"
                      [rangeStartLabel]="(pw.productObj.findTypeLodging ? 'app.lib.common.rangeStart.acc' : 'app.lib.common.rangeStart') | actrans | str"
                      [rangeEndLabel]="(pw.productObj.findTypeLodging ? 'app.lib.common.rangeEnd.acc' : 'app.lib.common.rangeEnd') | actrans | str"
                      [minRange]="pw.productObj.findMinRange"
                      [maxRange]="pw.productObj.findMaxRange"
                      [invalid]="dateInvalid"
                      [colors]="dateColors"
                      (onPageLoading)="dateOnPageLoading($event)"
                      (onChange)="dateRangeOnChange($event)"
                      class="ant-input"
                      />
                    </nz-input-group> -->
                    @if (pw.productObj.tcDate && !pw.productObj.singleDateProduct) {
                      @if (!pw.productObj.isStartBeforeEnd) {
                        <!--   [nzSize]="view.size"    [nzSize]="view.size" -->
                        <nz-input-group   class="inline-flex range-accommodation" [nzPrefixIcon]="opts.inlineDateTime || bas.ui.r.xs ? null : 'calendar'"  [nzSize]="view.size">
                          <!-- TODO: display: inline-block; på sm og md -->
                          <div class="inline-flex">
                            <nz-date-picker
                              [(ngModel)]="pw.periodArray[0]"
                              [ngModelOptions]="{standalone: true}"
                              [nzAllowClear]="false"
                              (ngModelChange)="onDateRangeChange(0, $event)"
                              [nzFormat]="'yyyy-MM-dd'"
                              [nzInputReadOnly]="bas.ui.r.xs"
                              [nzInline]="opts.inlineDateTime"
                              [nzDisabledDate]="pickerDisabledDate"
                              style="width: auto; min-width: 120px;"
                            ></nz-date-picker>
                          </div>
                          <div class="inline-flex mx-d"> <span nz-icon nzType="arrow-right" nzTheme="outline"></span> </div>
                          <div class="inline-flex">
                            <nz-date-picker
                              [(ngModel)]="pw.periodArray[1]"
                              [ngModelOptions]="{standalone: true}"
                              [nzAllowClear]="false"
                              (ngModelChange)="onDateRangeChange(1, $event)"
                              [nzFormat]="'yyyy-MM-dd'"
                              [nzInputReadOnly]="bas.ui.r.xs"
                              [nzInline]="opts.inlineDateTime"
                              [nzDisabledDate]="pickerDisabledDateRangeEnd"
                              style="width: auto; min-width: 120px;"
                            ></nz-date-picker>
                          </div>
                        </nz-input-group>
                      } @else {
                        <nz-input-group nzPrefixIcon="calendar"  [nzSize]="view.size">
                          <!-- <input
                          [(ngModel)]="pw.periodArray"
                          name="periodArray"
                          [ngModelOptions]="{standalone: true}"
                          mbsc-datepicker
                          [mbscOptions]="options.date"
                          [controls]="['calendar']"
                          select="range"
                          display="anchored"
                          [showOnFocus]="false"
                          [rangeStartLabel]="(pw.productObj.findTypeLodging ? 'app.lib.common.rangeStart.acc' : 'app.lib.common.rangeStart') | actrans | str"
                          [rangeEndLabel]="(pw.productObj.findTypeLodging ? 'app.lib.common.rangeEnd.acc' : 'app.lib.common.rangeEnd') | actrans | str"
                          [minRange]="pw.productObj.findMinRange"
                          [maxRange]="pw.productObj.findMaxRange"
                          [invalid]="dateInvalid"
                          (onPageLoading)="dateOnPageLoading($event)"
                          (onChange)="dateRangeOnChange($event)"
                          class="ant-input"
                          /> -->
                          <!--
                          [inRangeInvalid]="rangeOptions.inRangeInvalid" -->
                        <!-- TODO: det vises alle to kalendre også på xs, det er litt dumt i alle fall for langedrag. Skulle hatt dagvelger kanskje? -->
                        <nz-range-picker
                          [(ngModel)]="pw.periodArray"
                          [ngModelOptions]="{standalone: true}"
                          [nzAllowClear]="false"
                          [nzInputReadOnly]="bas.ui.r.xs"
                          [nzDisabledDate]="disabledDate"
                          [nzShowToday]="false"
                          (ngModelChange)="dateRangeOnChange($event)"
                          nzBorderless
                          [nzInline]="false"
                          class="w-100 no-border"
                        ></nz-range-picker>
                      </nz-input-group>
                    }
                  }
                  @if (pw.productObj.tcPeriod) {
                    <nz-input-group nzPrefixIcon="calendar"  [nzSize]="view.size">
                      <!-- <input
                      mbsc-datepicker
                      [controls]="['calendar']"
                      select="range"
                      display="anchored"
                      [rangeStartLabel]="'Innsjekk'"
                      [rangeEndLabel]="'Utsjekk'"
                      [(ngModel)]="pw.periodArray"
                      name="periodArray"
                      [ngModelOptions]="{standalone: true}"
                      [invalid]="dateInvalid"
                      (onPageLoading)="dateOnPageLoading($event)"
                      (onChange)="dateRangeOnChange($event)"
                      class="ant-input"
                      /> -->
                      @if ((pw.productPeriods || []).length > 1) {
                        <nz-select
                        [(ngModel)]="pw.productPeriodAsString"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onPeriodChange($event)"
                        >
                        @for (pp of pw.productPeriods || []; track pp) {
                          <nz-option
                            [nzValue]="pp.productPeriodAsString"
                            [nzLabel]="pp.label">
                          </nz-option>
                        }
                      </nz-select>
                      } @else {
                        <div class="m-1 ml-d">
                          {{ pw.periodString }}
                        </div>
                      }
            
                    </nz-input-group>
                  }
                  <!--TODO: annen visning? -->
                </div>
              </nz-form-control>
            </nz-form-item>
            @if (pw.findTimeArea) {
              <nz-form-item>
                <nz-form-control>
                  <nz-input-group>
                    <div>
                      <nz-alert class="mt-1" nzType="info" [nzMessage]="('common.venue' | actrans | str) + ': ' + pw.findTimeArea.mkName " nzShowIcon></nz-alert>
                    </div>
                  </nz-input-group>
                </nz-form-control>
              </nz-form-item>
            }
          </div>
        }
        @if (pw.productObj.tcTime) {
          <div nz-col
            [nzXs]="view.grid.date.xs"
            [nzSm]="view.grid.date.sm"
            [nzMd]="view.grid.date.md"
            [nzLg]="view.grid.date.lg"
            [nzXl]="view.grid.date.xl"
            [nzXXl]="view.grid.date.xxl"
            >
            <nz-form-item>
              <nz-form-label  class="" nzFor="">{{ ( (pw.timeItemsAvailable || []).length > 1 ? 'app.cbapi5.common.selectTime' : 'common.time') | actrans }}</nz-form-label>
              @if (!pw.productObj.useTimegrid || !pw.timeItemsAvailable?.length) {
                <nz-form-control  [nzErrorTip]="'app.cbapi5.common.selectTime' | actrans | str">
                  <nz-input-group nzPrefixIcon="clock-circle"  [nzSize]="view.size" style="padding: 3px 10px;">
                    @if ((pw.timeItemsAvailable || []).length > 1) {
                      <nz-select
                        [(ngModel)]="pw.timePeriodAsString"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onTimeChange($event)"
                        >
                        @for (ti of pw.timeItemsAvailable || []; track ti) {
                          <nz-option
                            [nzValue]="ti.timePeriod"
                            [nzLabel]="ti.timePeriodDisplay">
                          </nz-option>
                        }
                        <!-- <nz-option nzValue="15:30" nzLabel="15:30" nzDisabled></nz-option> -->
                      </nz-select>
                    }
                    @if ((pw.timeItemsAvailable || []).length <= 1) {
                      <div class="m-1 ml-d">
                        {{ pw.startTimeAsString }}
                      </div>
                    }
                  </nz-input-group>
                </nz-form-control>
              }
              @if (pw.productObj.useTimegrid && pw.timeItemsAvailable?.length) {
                <nz-form-control id="fc-timegrid">
                  <!-- <div *ngIf="bas.ui.r.ltexs || true">
                  <nz-input-group *ngFor="let ti of pw.timeItemsAvailable"  nzPrefixIcon="clock-circle"  [nzSize]="view.size" style="padding: 3px 10px;">
                    <nz-select
                      class="" style="width: 48%; margin-left: 2%;"
                      nzDropdownClassName="timegrid-dropdown"
                      [(ngModel)]="timegrid.startTime"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onTimegridChange('start', $event)"
                      >
                      <nz-option
                        *ngFor="let item of timegrid.items"
                        [nzValue]="item.startTimeAsString"
                        [nzLabel]="item.startTimeAsString"
                        [nzDisabled]="!item.validStart">
                      </nz-option>
                    </nz-select>
                    <nz-select
                      class="" style="width: 48%; margin-left: 2%;"
                      nzDropdownClassName="timegrid-dropdown"
                      [(ngModel)]="timegrid.endTime"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onTimegridChange('end', $event)"
                      >
                      <nz-option
                        *ngFor="let item of timegrid.items | filterBy: { endTimeAfterStart: true }"
                        [nzValue]="item.startTimeAsString"
                        [nzLabel]="item.startTimeAsString"
                        [nzDisabled]="!item.validEnd">
                      </nz-option>
                      <nz-option
                        *ngIf="timegrid.lastEndItem"
                        [nzValue]="timegrid.lastEndItem.startTimeAsString"
                        [nzLabel]="timegrid.lastEndItem.startTimeAsString"
                        >
                      </nz-option>
                    </nz-select>
                  </nz-input-group>
                </div> -->
                <div>
                  <button
                    nz-button
                    nzBlock class="text-left"
                    style=""
                    nzSize="large"
                    (click)="showTimegrid()"
                    >
                    <span nz-icon nzType="clock-circle"></span>
                    <span class="text-lg-off"> {{ timegrid.label | actrans }}</span>
                  </button>
                  <nz-drawer
                    nzWrapClassName="drawer-responsive"
                    [nzClosable]="true"
                    [nzVisible]="timegrid.visible"
                    [nzPlacement]="bas.ui.r.ltesm ? 'top' : 'bottom'"
                    [nzTitle]="timegrid.label"
                    [nzFooter]="footerTpl"
                    [nzHeight]="bas.ui.r.h > 690 ? '670px' : '90%'"
                    [nzZIndex]="1005"
                    (nzOnClose)="timegrid.visible = false;"
                    >
                    <ng-container *nzDrawerContent >
                      @for (ti of pw.timeItemsAvailable; track ti) {
                        <div nz-row [nzGutter]="16">
                          <div nz-col [nzXs]="24" [nzSm]="12">
                            <nz-collapse>
                              <nz-collapse-panel [nzHeader]="('common.from' | actrans | str) + ': ' + timegrid.startTime" [nzActive]="timegrid.collapseStart" [nzShowArrow]="false">
                                <!-- <h2>{{ 'common.from' | actrans }}</h2> -->
                                <mbsc-datepicker
                                  [controls]="['timegrid']"
                                  [display]="'inline'"
                                  class="timegrid-timepicker inline-block w-100"
                                  style=""
                                  [minTime]="ti.startTimeAsString"
                                  [maxTime]="ti.endTimeAsString"
                                  [stepMinute]="ti.duration"
                                  [valid]="validStart()"
                                  [(ngModel)]="timegrid.start"
                                  [ngModelOptions]="{standalone: true}"
                                  (onChange)="onTimegridChange('start', $event)"
                                  >
                                </mbsc-datepicker>
                                <!--
                                [display]="bas.ui.r.gtesm ? 'inline' : 'anchored'"
                                -->
                              </nz-collapse-panel>
                            </nz-collapse>
                          </div>
                          <div nz-col  [nzXs]="24" [nzSm]="12" [style]="bas.ui.r.gtesm ? 'border-left: 1px black solid;' : ''">
                            <nz-collapse>
                              <nz-collapse-panel [nzHeader]="('common.to' | actrans | str) + ': ' + timegrid.endTime" [nzActive]="timegrid.collapseEnd" [nzShowArrow]="false">
                                <!-- <h2>{{ 'common.to' | actrans }}</h2> -->
                                <mbsc-datepicker
                                  [controls]="['timegrid']"
                                  [display]="'inline'"
                                  class="timegrid-timepicker inline-block w-100"
                                  style=""
                                  [minTime]="ti.startTimeAsString"
                                  [maxTime]="ti.endTimeAsString"
                                  [stepMinute]="ti.duration"
                                  [valid]="validEnd()"
                                  [(ngModel)]="timegrid.end"
                                  [ngModelOptions]="{standalone: true}"
                                  (onChange)="onTimegridChange('end', $event)"
                                  >
                                </mbsc-datepicker>
                              </nz-collapse-panel>
                            </nz-collapse>
                          </div>
                        </div>
                      }
                    </ng-container>
                    <ng-template #footerTpl>
                      <div class="text-right">
                        <button
                          nz-button
                          nzType="primary"
                          (click)="timegrid.visible = false; timegridVisibleChange(false);"
                          style=""
                          >
                          {{ 'common.close' | actrans }}
                        </button>
                      </div>
                    </ng-template>
                  </nz-drawer>
                </div>
                @if (bas.ui.r.gtesm && false) {
                  <div>
                    <button
                      nz-button
                      nzBlock
                      [nzSize]="view.size"
                      nz-dropdown
                      nzTrigger="click"
                      [nzDropdownMenu]="timegridPopup"
                      [(nzVisible)]="timegrid.visible"
                      (nzVisibleChange)="timegridVisibleChange($event)"
                      class="text-left"
                      style=""
                      >
                      <span nz-icon nzType="clock-circle"></span>
                      <span class="text-lg-off"> {{ timegrid.label | actrans }}</span>
                    </button>
                    <nz-dropdown-menu #timegridPopup="nzDropdownMenu">
                      <div nz-menu>
                        <!-- <i nz-icon nzType="close" class="pull-right p-3" (click)="timegrid.visible = false; timegridVisibleChange(false);" ></i>  -->
                        <div class="p-3-off m-d">
                          <!-- TODO: mobil, bruke start-end som er standard i mobiscroll?  -->
                          @for (ti of pw.timeItemsAvailable; track ti) {
                            <div nz-row [nzGutter]="16">
                              <div nz-col [nzXs]="24" [nzSm]="12">
                                <h2>{{ 'common.from' | actrans }}</h2>
                                <mbsc-datepicker
                                  [controls]="['timegrid']"
                                  [display]="'inline'"
                                  class="timegrid-timepicker inline-block w-100"
                                  style=""
                                  [minTime]="ti.startTimeAsString"
                                  [maxTime]="ti.endTimeAsString"
                                  [stepMinute]="ti.duration"
                                  [valid]="validStart()"
                                  [(ngModel)]="timegrid.start"
                                  [ngModelOptions]="{standalone: true}"
                                  (onChange)="onTimegridChange('start', $event)"
                                  >
                                </mbsc-datepicker>
                                <!--
                                [display]="bas.ui.r.gtesm ? 'inline' : 'anchored'"
                                -->
                              </div>
                              <div nz-col  [nzXs]="24" [nzSm]="12" style="border-left: 1px black solid;">
                                <h2>{{ 'common.to' | actrans }}</h2>
                                <mbsc-datepicker
                                  [controls]="['timegrid']"
                                  [display]="'inline'"
                                  class="timegrid-timepicker inline-block w-100"
                                  style=""
                                  [minTime]="ti.startTimeAsString"
                                  [maxTime]="ti.endTimeAsString"
                                  [stepMinute]="ti.duration"
                                  [valid]="validEnd()"
                                  [(ngModel)]="timegrid.end"
                                  [ngModelOptions]="{standalone: true}"
                                  (onChange)="onTimegridChange('end', $event)"
                                  >
                                </mbsc-datepicker>
                              </div>
                            </div>
                          }
                          <div class="text-right">
                            <button
                              nz-button
                              nzType="default"
                              [nzSize]="'small'"
                              (click)="timegrid.visible = false; timegridVisibleChange(false);"
                              style=""
                              >
                              {{ 'common.close' | actrans }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </nz-dropdown-menu>
                  </div>
                }
              </nz-form-control>
            }
          </nz-form-item>
        </div>
      }
    }
    @if (pw.productObj.findGuestProduct) {
      <div nz-col
        [nzXs]="view.grid.guests.xs"
        [nzSm]="view.grid.guests.sm"
        [nzMd]="view.grid.guests.md"
        [nzLg]="view.grid.guests.lg"
        [nzXl]="view.grid.guests.xl"
        [nzXXl]="view.grid.guests.xxl"
        class=""
        >
        <btlib-select-guests [pw]="pw" [gcs]="pw.guestCounts" (change)="onGuestsUpdate($event)" ></btlib-select-guests>
      </div>
    }
    @if (pw.productObj.findIsPriceCustom) {
      <div nz-col
        [nzXs]="view.grid.guests.xs"
        [nzSm]="view.grid.guests.sm"
        [nzMd]="view.grid.guests.md"
        [nzLg]="view.grid.guests.lg"
        [nzXl]="view.grid.guests.xl"
        [nzXXl]="view.grid.guests.xxl"
        >
        <nz-form-item>
          <nz-form-control class="custom-style" >
            <nz-input-number
              class="w-100"
              [nzAddonBefore]="'kr'"
              [(ngModel)]="pw.customAmountDouble"
              [ngModelOptions]="{standalone: true}"
              [nzStep]="50"
              [nzMin]="bas.us.checkEmpty(pw.productObj.findCustomPriceMinDouble, 10)"
              [nzMax]="bas.us.checkEmpty(pw.productObj.findCustomPriceMaxDouble, bas.us.Infinity)"
              (ngModelChange)="onChange($event, 'customAmountDouble')"
            ></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
    }
    @if (opts.showCampaignCode && pw.productObj.showCampaignCodeField) {
      <div nz-col
        [nzXs]="view.grid.guests.xs"
        [nzSm]="view.grid.guests.sm"
        [nzMd]="view.grid.guests.md"
        [nzLg]="view.grid.guests.lg"
        [nzXl]="view.grid.guests.xl"
        [nzXXl]="view.grid.guests.xxl"
        >
        <nz-form-item>
          <nz-form-label  class="">{{ 'bus.campaign.code' | actrans }}</nz-form-label>
          <nz-form-control class="custom-style" >
            <input nz-input
              [nzSize]="view.size"
              [(ngModel)]="pw.campaignCode"
              [ngModelOptions]="{standalone: true}"
              (change)="onChange($event, 'campaignCode')"
              />
          </nz-form-control>
        </nz-form-item>
      </div>
    }
  </div>
</form>
</div>
}
